export const REFRESH_INPROCESS_INTERACTIONS = 'REFRESH_INPROCESS_INTERACTIONS';
export const REFRESH_HISTO_INTERACTIONS = 'REFRESH_HISTO_INTERACTIONS';

export type HistoryPopinMode = 'INPROCESS' | 'HISTO' | 'NOT_ALLOWED' | '';

export interface ISortByNameAndOrder {
  name: string;
  order: string;
}
